import { useCallback, useRef } from "react";

/**
 * Scroll behavior for Universal Chat's flipped (column-reverse) message list.
 *
 * We deliberately don't auto-scroll on new messages — that interrupts a
 * provider reading past messages (EHR-8521). Returning to the newest message
 * is manual, via the "Jump to latest message" button.
 */
export const useUniversalChatScroll = () => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // Newest message sits at scrollTop 0 in the flipped container.
  const scrollToNewest = useCallback(() => {
    scrollContainerRef.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return {
    scrollContainerRef,
    scrollToNewest,
  };
};
